module.exports = __webpack_public_path__ + "media/images/icon-7f09972ac860ff656809ad0607c0bc67.svg";